import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {
	Loading, Icon, Button, Modal
} from "~/components";
import {
	apiError,
	handleRequest
} from "~/utils";
import {
	ReceiptGroupTable,
	ReceiptGroupFormAddEdit
} from "../components";
import {
	receiptApi
} from "~/api";
import {
	receiptGroupActions,
	receiptGroupItemsSelector,
	receiptGroupLoadingSelector,
	receiptGroupErrorSelector,
	receiptGroupPaginationSelector,
	receiptGroupFilterSelector
} from "../receiptGroupSlice";

function ReceiptGroup() {

	const dispatch   = useDispatch();

	const items      = useSelector(receiptGroupItemsSelector);

	const loading    = useSelector(receiptGroupLoadingSelector);

	const error      = useSelector(receiptGroupErrorSelector);

	const pagination = useSelector(receiptGroupPaginationSelector);

	const filter     = useSelector(receiptGroupFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	const [openModal, setOpenModal] = useState({
		addEdit: false,
		delete: false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	useEffect(() => {
		dispatch(receiptGroupActions.fetchData(filter));
	}, [filter]);

	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';

		if(isEdit) {
			if (!itemEdit?.id) {
				notification.error({message: 'Lỗi', description: 'Không có thông tin loại phiếu thu để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}

		let [error, response] = (isEdit) ? await handleRequest(receiptApi.groupUpdate(data)) : await handleRequest(receiptApi.groupAdd(data));

		let message = apiError(`${messageAction} loại phiếu thu thất bại`, error, response);

		if(!message) {
			notification.success({message: 'Thành công', description: `${messageAction} loại phiếu thu thành công`});

			if(!isEdit) {
				dispatch(receiptGroupActions.add(response.data));
			}
			else {
				setItemEdit(response.data);
				dispatch(receiptGroupActions.update(response.data));
			}
			handleModalClose('addEdit')
		}
	}

	const handleDelete = async () => {
		if (!itemEdit?.id) {
			notification.error({message: 'Lỗi', description: 'Không có thông tin loại phiếu thu để xóa'});
			return;
		}
		let [error, response] = await handleRequest(receiptApi.groupDelete(itemEdit.id));

		let message = apiError(`Xóa loại phiếu thu thất bại`, error, response);

		if(!message) {
			notification.success({message: 'Thành công', description: `Xóa loại phiếu thu thành công`});
			dispatch(receiptGroupActions.delete(itemEdit.id));
			handleModalClose('delete')
		}
	}

	const handlePaginationChange = (page) => {
		dispatch(receiptGroupActions.setFilter({...filter, page}));
	}

	return (
		<Fragment>
			<ActionBar title={'Loại phiếu thu'}>
				<Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({}); handleModalOpen('addEdit')}}>Thêm mới</Button>
				<Button outline blue to="/receipt">Phiếu thu</Button>
				<Button background blue to="/receipt/group">Loại phiếu thu</Button>
				<Button outline blue to="/expense">Phiếu chi</Button>
			</ActionBar>
			<div className="container">
				<div className="content">
					{loading && <Loading/>}
					{items && <ReceiptGroupTable
						items={items}
						pagination={pagination}
						onPaginationChange={handlePaginationChange}
						setItemEdit={setItemEdit}
						openModal={handleModalOpen}
					/>}
				</div>
				{
					<Modal title="Loại phiếu thu" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
						<ReceiptGroupFormAddEdit item={itemEdit} onHandleSubmit={handleSaveItem} />
					</Modal>
				}
				{
					(itemEdit?.id) && <Modal title="Xóa loại phiếu thu" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
						<p>Bạn muốn xóa loại phiếu thu <b>{itemEdit?.name}</b>?</p>
						<div className="d-flex justify-content-end gap pd-1 modal-bottom">
							<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
							<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
						</div>
					</Modal>
				}
			</div>
		</Fragment>
	)
}

export default ReceiptGroup;

